module.exports = __webpack_public_path__ + "img/67800.39a67155.jpg";